import React, { useContext, useCallback } from 'react'
import { ScreenContext, ChatMessageBox } from 'react-components'

import { CustomerSupportSectionTransport } from '@common/transports/deprecated-home-page-transport'
import {
    Container,
    CustomerSupportParaContent,
    CustomerSupportBoldParaContent,
    ContactImgContent,
    ContactDetailsContainer,
    ContactEmailContainer,
    ContactNumberContainer,
    ChatMessageBoxContainer,
    EmailLinkContent,
    ContentContainer,
    ChatMessageContent,
    ContactImageContainer,
    InnerContainer,
} from './customer-support-section-styles'
import { AnalyticsService } from '@src/services'
import { homePageEventCategories } from '@src/services/analytics-service/categories'

interface Props {
    customerSupportSection: CustomerSupportSectionTransport
}

const CustomerSupportSection: React.FC<Props> = ({ customerSupportSection: { id, title, subtitle, contact } }) => {
    const { isDesktop } = useContext(ScreenContext)
    const direction = isDesktop ? 'right' : 'bottom'

    const _handlePhoneClick = useCallback(() => {
        if (contact.phone.eventLabel) {
            AnalyticsService.trackClickEvent(homePageEventCategories.CUSTOMER_SUPPORT_SECTION, contact.phone.eventLabel)
        }
    }, [contact.phone])

    const _handleEmailClick = useCallback(() => {
        if (contact.email.eventLabel) {
            AnalyticsService.trackClickEvent(homePageEventCategories.CUSTOMER_SUPPORT_SECTION, contact.email.eventLabel)
        }
    }, [contact.email])

    return (
        <Container id={id}>
            <InnerContainer>
                <ChatMessageBoxContainer>
                    <ChatMessageBox direction={direction}>
                        <ChatMessageContent>
                            <ContactImageContainer>
                                <ContactImgContent src={contact.image.url} alt={contact.image.alt} />
                            </ContactImageContainer>

                            <ContactDetailsContainer>
                                <ContactNumberContainer onClick={_handlePhoneClick} href={contact.phone.url}>
                                    {contact.phone.text}
                                </ContactNumberContainer>
                                <ContactEmailContainer>
                                    {contact.additionalText}&nbsp;
                                    <EmailLinkContent onClick={_handleEmailClick} href={contact.email.url}>
                                        {contact.email.text}
                                    </EmailLinkContent>
                                </ContactEmailContainer>
                            </ContactDetailsContainer>
                        </ChatMessageContent>
                    </ChatMessageBox>
                </ChatMessageBoxContainer>
                <ContentContainer>
                    <CustomerSupportParaContent>{subtitle}</CustomerSupportParaContent>
                    <CustomerSupportBoldParaContent>{title}</CustomerSupportBoldParaContent>
                </ContentContainer>
            </InnerContainer>
        </Container>
    )
}

export default CustomerSupportSection
